module.exports = __webpack_public_path__ + "img/BAU_Partners_1.cbe2fc08.jpg";